import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})

export class EmbedService {


  constructor(private httpService: HttpClient) { }

  domainDetails(data:any) {
    return this.httpService.post('/whiteListDomain/fetch',data);
  }

  getClubDetail(data:any) {
		return this.httpService.post("/videoListing/clubList",data);
	 }

  getClubMatchList(payload: any = {}){
    return this.httpService.post("/videoListing/get-club-data",payload)
  }


  getClubMatchesPlayers(payload: {
  clubId: any;
  }) {
    return this.httpService.post(
      "/videoListing/get-club-matches-players",payload );
  }


   getClubInformation(data:any) {
		return this.httpService.post("/videoListing/clublanginfo",data);
	 }


    captureScreenshot(urlToCapture:any){
    return this.httpService.post("/videoListing/capture-screenshot",urlToCapture,{ responseType: 'blob' });
    }


    createWidgets(data:any){
      return this.httpService.post("/custom-widgets/create",data)
    }

    uploadWidgetImage(data:any){
      return this.httpService.post("/custom-widgets/uploadWidgetImage",data)
    }
}
